module.exports = __webpack_public_path__ + "static/media/step4.e866cfad.png";